export default __webpack_public_path__ + "static/media/ic-sub.9177053d.svg";